import { apiSlice } from '../../../api/apiSlice';
import * as constants from '../../../constants';

export const CaConfigureSLice = apiSlice.injectEndpoints({
    endpoints : (builder : any) => ({
        getCaSeverityLevel :builder.query({
            query: (arg:any) => {
                const {  countryId, misconductId, isHCUser } = arg;
                return {
                    url: constants.CA_SEVERITY_LEVEL,
                    params: { countryId, misconductId, isHCUser}
                };
            }
        }),
        getCaLanguage :builder.query({
            query: () => {
                return {
                    url: constants.CA_LANGUAGE,
                };
            }
        }),
        getCaTokens :builder.query({
            query: () => {
                return {
                    url: constants.CA_TOKENS,
                };
            }
        }),
        getCaTemplateNotice : builder.query({
            query : (arg :any) => {
                const { caTemplateId } = arg;
                return {
                    url : constants.CA_TEMPLATE_NOTICE,
                    params: {caTemplateId }
                }
            },
            providesTags : ['Corrective_action']
        }),
        createConfigure: builder.mutation({
            query: (arg: any) => ({
                url: constants.CA_CREATE_CONFIGURE,
                method: 'POST',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['Corrective_action'],
        }),
        updateConfigure: builder.mutation({
            query: (arg: any) => ({
                url: constants.CA_UPDATED_CONFIGURE,
                method: 'PUT',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['Corrective_action'],
        }),

        updateConfigureStatus : builder.mutation({
            query : (arg :any) => ({
                url: constants.CA_NOTICE_UPDATE_STATUS,
                method: 'PUT',
                params: { caTemplateNoticeId: arg.caTemplateNoticeId, caModifyby :arg.caModifyby},
                body: {},
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['Corrective_action'],
        }),

        getCaTemplateLanguage :builder.query({
            query: (arg: any) => {
                const { countryId, categoryId, scorecardRoleId } = arg;             
                return {
                    url: constants.GET_CA_TEMPLAT_LANGUAGE,
                    params: { countryId, categoryId, scorecardRoleId },
                };
            }
        }),
    })
})

export const {
    useGetCaSeverityLevelQuery,
    useGetCaLanguageQuery,
    useGetCaTokensQuery,
    useCreateConfigureMutation,
    useUpdateConfigureMutation,
    useGetCaTemplateNoticeQuery,
    useUpdateConfigureStatusMutation,
    useGetCaTemplateLanguageQuery,
} = CaConfigureSLice